import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Volgblad } from '../dto/volgblad';
import { CrudService, Filter } from '@mango/core';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class VolgbladService extends CrudService<Volgblad> {

    constructor(injector: Injector) { super(Volgblad, injector); }

    kopieerVolgblad(volgblad: Volgblad) {
        let query: string = `api/dto/volgblad/kopieer?volgbladId=${volgblad.id}`;

        return this.http.post(query, null).pipe(map(x => x as VolgbladResponse));

    } 

    getIdFilter(Id: number): Filter<Volgblad> {
        return new Filter<Volgblad>(fb => [fb.equal("id", Id)]);        
    }

    getActiefFilter(): Filter<Volgblad> {
        return new Filter<Volgblad>(fb => [fb.equal("actief",true)]);
    }

    openDirectory(dir: string) {

        let query: string = `http://localhost:3000/?location=${dir}`;

        window.open(query,"_blank");

    }
}


export class VolgbladResponse {
    successful: boolean;
    volgbladId: number;
    message: string;
}